import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'semantic-ui-react'

const IntegrationAuthenticationSegment = ({
  name,
  isAuthenticated,
  onActivate,
  onDeactivate,
  loading,
}) =>
  isAuthenticated ? (
    <div className="ui segment">
      <div className="ui stackable grid">
        <div className="ten wide column middle aligned">
          <h4>
            <i className="ui icon fas fa-check green" />
            Authenticated with {name}
          </h4>
        </div>

        <div className="six wide column right aligned">
          <Button basic negative onClick={onDeactivate} loading={loading} disabled={loading}>
            Revoke access
          </Button>
        </div>
      </div>
    </div>
  ) : (
    <div className="ui secondary segment !bg-white">
      <div className="ui stackable grid">
        <div className="ten wide column middle aligned">
          <h4>
            <i className="ui icon info circle" />
            Connect your {name} account with Simplesat
          </h4>
        </div>

        <div className="six wide column right aligned">
          <Button primary onClick={onActivate} loading={loading} disabled={loading}>
            Authenticate
          </Button>
        </div>
      </div>
    </div>
  )

IntegrationAuthenticationSegment.propTypes = {
  name: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool,
  onActivate: PropTypes.func,
  onDeactivate: PropTypes.func,
  loading: PropTypes.bool.isRequired,
}

export default IntegrationAuthenticationSegment



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntegrationAuthenticationSegment/index.js